var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9369 0.645766C13.5544 1.21553 13.5544 2.1394 12.9369 2.70916L5.49377 9.57708L1.21313 5.62727C0.595622 5.05751 0.595622 4.13364 1.21313 3.56388C1.83066 2.99411 2.83185 2.99411 3.44938 3.56388L5.49377 5.45029L10.7007 0.645766C11.3182 0.0760046 12.3194 0.0760046 12.9369 0.645766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionChecked);
export default __webpack_public_path__ + "static/media/questionChecked.25508c843dec79bcb8b264e614066d10.svg";
export { ForwardRef as ReactComponent };